// extracted by mini-css-extract-plugin
module.exports = {"inner":"_97a0a89","content":"_147144b","article":"_0ca367c","center":"_52f56c3","title":"_82c514b","articleBody":"_c808c34","sideBar":"_75b389a","articleDetailSkeleton":"_3f96846"};